/* eslint-disable array-callback-return */
// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
// local
import { Accordion, Transition } from 'semantic-ui-react';
// stylesheets
import './MainMenu.scss';
// images
import logo from 'assets/images/logo-salvus.png';
import logoSmall from 'assets/images/logo-small.jpeg';
// button
// import FixateMenuButton from '../commons/button/FixateMenuButton';
import FixateMenuButton from 'app/components/home/components/FixateMenuButton';
// icons
import ArrowIcon from 'assets/icon/arrow-icon/ArrowIcon';
import DashboardIcon from 'assets/icon/dashboard-icon/DashboardIcon';
// icons menus
import CalendarIcon from 'assets/icon/calendar-icon/CalendarIcon'; // Menu visita
import PadIcon from 'assets/icon/pad-icon/PadIcon'; // Menu PAD
import UserIcon from 'assets/icon/user-icon/UserIcon'; // Menu usuário
import PepIcon from 'assets/icon/pep-icon/PepIcon'; // Menu PEP
import RegisterIcon from 'assets/icon/register-icon/RegisterIcon'; // Menu Cadastro
import OrganizationalIcon from 'assets/icon/organizational-icon/OrganizationalIcon'; // Menu Organizacional
import TerminologyIcon from 'assets/icon/terminology-icon/TerminologyIcon'; // Menu Terminologia
import ReportIcon from 'assets/icon/report-icon/ReportIcon'; // Menu Relatórios
// menu
import { getMenu } from './routes';
import { MENU } from 'app/config/mainMenu';
// consts
import { COLORS } from 'app/config/colors';

const MenuItemOther = props => {
  const { title, icon } = props;
  return (
    <li className='nav-link'>
      <NavLink to={props.path} exact={props.exact} title={props.title}>
        <div>
          <span>{title}</span>
          {icon && <span>{icon}</span>}
        </div>
      </NavLink>
    </li>
  );
};

MenuItemOther.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  icon: PropTypes.string,
  image: PropTypes.string,
  section: PropTypes.number
};

class MainMenu extends Component {
  state = {
    activeIndex: 0,
    close: true,
    isHovered: false,
    fixed: false,
    activeHover: null
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  menu = getMenu(this.props.account);

  accordionTitle = (activeIndex, menu, icon, title, iconGreen) => {
    return (
      <Accordion.Title
        style={{ height: '60px' }}
        active={activeIndex === menu}
        index={menu}
        onClick={this.handleClick}
        className='menu-title'
        onMouseOver={() => {
          if (this.state.activeHover !== menu) {
            this.setState({ activeHover: menu });
          }
        }}
        onMouseOut={() => {
          if (this.state.activeHover !== null) {
            this.setState({ activeHover: null });
          }
        }}
      >
        {this.state.activeHover === menu || activeIndex === menu ? (
          <div className='wrapper-icon-open'>{iconGreen}</div>
        ) : (
          <div className='wrapper-icon-open'>{icon}</div>
        )}
        <div className='group'>
          <div>{title}</div>
          <div className='dropdown-menu-div'>
            {activeIndex === menu ? (
              <ArrowIcon direction='up' fill={COLORS.PRIMARY_VARIANT_DARK} />
            ) : (
              <ArrowIcon
                direction='down'
                fill={this.state.activeHover === menu ? COLORS.PRIMARY_VARIANT_DARK : undefined}
              />
            )}
          </div>
        </div>
      </Accordion.Title>
    );
  };

  accordionContent = (activeIndex, menu) => {
    return (
      <Accordion.Content active={activeIndex === menu} className={'wrapper-content'}>
        <Transition duration={300} animation={'slide down'} visible={activeIndex === menu}>
          <ul>
            {this.menu.map(item => {
              if (item.section === menu) {
                return <MenuItemOther key={`menu-${item.path}`} {...item} />;
              }
            })}
          </ul>
        </Transition>
      </Accordion.Content>
    );
  };

  menuItem = (activeIndex, menu, icon, title, iconGreen) => {
    return (
      <>
        {this.accordionTitle(activeIndex, menu, icon, title, iconGreen)}
        {this.accordionContent(activeIndex, menu)}
      </>
    );
  };

  isThereContentOnTheMenu = menu => {
    return this.menu.filter(item => item.section === menu).length > 0;
  };

  render() {
    const { activeIndex } = this.state;

    const sizeIconOpen = '20';
    const sizeIconClose = '20';

    const menu = [
      {
        menu: MENU.DASHBOARD,
        title: 'DASHBOARDS',
        icon: <DashboardIcon size={sizeIconClose} fill={COLORS.SECONDARY_VARIANT_DARK} />,
        iconGreen: <DashboardIcon size={sizeIconClose} fill={COLORS.ACCENTUATED_VARIANT} />
      },
      {
        menu: MENU.VISIT,
        title: 'VISITA',
        icon: <CalendarIcon size={sizeIconClose} fill={COLORS.SECONDARY_VARIANT_DARK} />,
        iconGreen: <CalendarIcon size={sizeIconClose} fill={COLORS.ACCENTUATED_VARIANT} />
      },
      {
        menu: MENU.PAD,
        title: 'PAD',
        icon: <PadIcon size={sizeIconOpen} fill={COLORS.SECONDARY_VARIANT_DARK} />,
        iconGreen: <PadIcon size={sizeIconClose} fill={COLORS.ACCENTUATED_VARIANT} />
      },
      {
        menu: MENU.PEP,
        title: 'PEP',
        icon: <PepIcon size={sizeIconOpen} fill={COLORS.SECONDARY_VARIANT_DARK} />,
        iconGreen: <PepIcon size={sizeIconClose} fill={COLORS.ACCENTUATED_VARIANT} />
      },
      {
        menu: MENU.REPORT,
        title: 'RELATÓRIOS',
        icon: <ReportIcon size={sizeIconOpen} fill={COLORS.SECONDARY_VARIANT_DARK} />,
        iconGreen: <ReportIcon size={sizeIconClose} fill={COLORS.ACCENTUATED_VARIANT} />
      },
      {
        menu: MENU.USERS,
        title: 'USUÁRIOS',
        icon: <UserIcon size={sizeIconOpen} fill={COLORS.SECONDARY_VARIANT_DARK} />,
        iconGreen: <UserIcon size={sizeIconClose} fill={COLORS.ACCENTUATED_VARIANT} />
      },
      {
        menu: MENU.ORGANIZATIONAL,
        title: 'ORGANIZACIONAL',
        icon: <OrganizationalIcon size={sizeIconOpen} fill={COLORS.SECONDARY_VARIANT_DARK} />,
        iconGreen: <OrganizationalIcon size={sizeIconOpen} fill={COLORS.ACCENTUATED_VARIANT} />
      },

      {
        menu: MENU.REGISTRATION,
        title: 'CADASTROS',
        icon: <RegisterIcon size={sizeIconOpen} fill={COLORS.SECONDARY_VARIANT_DARK} />,
        iconGreen: <RegisterIcon size={sizeIconClose} fill={COLORS.ACCENTUATED_VARIANT} />
      },
      {
        menu: MENU.TERMINOLOGY,
        title: 'TERMINOLOGIA',
        icon: <TerminologyIcon size={sizeIconOpen} fill={COLORS.SECONDARY_VARIANT_DARK} />,
        iconGreen: <TerminologyIcon size={sizeIconClose} fill={COLORS.ACCENTUATED_VARIANT} />
      }
    ];

    return (
      <div id='main-menu' style={this.props.close ? { width: '70px' } : { width: '260px' }}>
        <div className={'wrapper-menu-list'}>
          <div className={`logo-small-div ${this.props.close ? 'close' : 'open'}`}>
            <img
              className={this.props.close ? 'logo-small' : ''}
              src={this.props.close ? logoSmall : logo}
              alt='Salvus'
            />
          </div>
          {this.props.close ? (
            <div className='wrapAccordion'>
              <div className='icons'>
                {menu.map(menuItem => {
                  const { menu, iconGreen, icon } = menuItem;
                  return (
                    this.isThereContentOnTheMenu(menu) && (
                      <div className='icon' key={menu}>
                        {menu === activeIndex ? iconGreen : icon}
                      </div>
                    )
                  );
                })}
              </div>
            </div>
          ) : (
            <div className='wrapperAccordion'>
              <Accordion className='accordion-menu'>
                {menu.map(menuItem => {
                  const { menu, title, icon, iconGreen } = menuItem;

                  return (
                    this.isThereContentOnTheMenu(menu) &&
                    this.menuItem(activeIndex, menu, icon, title, iconGreen)
                  );
                })}
              </Accordion>
            </div>
          )}
        </div>
        <FixateMenuButton
          menuState={{ close: this.props.close, fixed: this.props.fixed }}
          handleState={this.props.handleState}
        />
      </div>
    );
  }
}

MainMenu.propTypes = {
  account: PropTypes.object,
  close: PropTypes.bool,
  onChange: PropTypes.func,
  fixed: PropTypes.bool,
  handleState: PropTypes.func
};

export default MainMenu;
